// OccupancyDaysCell.jsx
import { useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { formatHour } from '@/utils/formatters';

const ORDER = [
  { key: 'Monday', label: 'M' },
  { key: 'Tuesday', label: 'T' },
  { key: 'Wednesday', label: 'O' },
  { key: 'Thursday', label: 'T' },
  { key: 'Friday', label: 'F' },
  { key: 'Saturday', label: 'L' },
  { key: 'Sunday', label: 'S' },
];

export default function OccupancyDaysCell({ daysOfWeek, dense = true }) {
  // stable array to map + avoid re-renders when object identity changes
  const items = useMemo(
    () => ORDER.map((d) => ({ ...d, ...daysOfWeek?.[d.key] })),
    [daysOfWeek],
  );
  if (daysOfWeek === null) return null;
  if (daysOfWeek === undefined) return null;
  return (
    <Box
      role="group"
      aria-label="Aktive ugedage"
      sx={{
        display: 'flex',
        gap: 0.5, // tighter spacing than ToggleButton
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        px: 0.2,
      }}
    >
      {items?.map(({ key, label, occupancy, start_time, end_time }) => (
        <Tooltip
          key={key}
          title={
            occupancy
              ? `${formatHour(start_time)}-${formatHour(end_time)}`
              : `Inaktiv`
          }
        >
          <Box
            role="img"
            aria-label={`${key} ${occupancy ? 'aktiv' : 'inaktiv'}`}
            sx={(theme) => {
              const on =
                theme.palette.mode === 'dark'
                  ? theme.palette.grey[200]
                  : theme.palette.grey[700];

              const offBorder = theme.palette.divider;
              const offBg = alpha(theme.palette.text.primary, 0.04);
              const size = dense ? 18 : 22;

              return {
                width: size,
                height: size,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: dense ? 10 : 12,
                fontWeight: 700,
                lineHeight: 1,
                borderRadius: 4,
                userSelect: 'none',
                // occupancy vs inoccupancy
                backgroundColor: occupancy ? on : offBg,
                color: occupancy
                  ? theme.palette.getContrastText(on)
                  : theme.palette.text.secondary,
                border: '1px solid',
                borderColor: occupancy ? on : offBorder,
                // avoid layout shift in dense DataGrid rows
                boxSizing: 'border-box',
              };
            }}
          >
            {label}
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}
